
import { Options, Vue } from "vue-class-component";
import GuestCard from "./components/GuestCard.vue";
import MainHeader from "./components/MainHeader.vue";
import MainHeaderSortMenu from "./components/MainHeaderSortMenu.vue";
import AlphabetMenu from "./components/AlphabetMenu.vue";
import DayMenuButtons from "./components/DayMenuButtons.vue";
import NoResults from "./components/NoResults.vue";
// @ts-ignore
import guests from "./data/guestData.js";
import * as data from "./data/data.json";
import { sortedDays, routeChoice, searchFilter } from "./data/functions";
import { MutationTypes } from "./store/mutation-types";
import { useStore } from "./store";

@Options({
  components: {
    MainHeader,
    MainHeaderSortMenu,
    GuestCard,
    AlphabetMenu,
    DayMenuButtons,
    NoResults,
  },
  mounted() {
    window.scrollTo(0, 0);
    // removes filter results on load
    this.store.commit(MutationTypes.SET_SEARCH, "");
    this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
      programId: "",
      guestType: "",
      tag: [],
    }),
      this.store.commit(MutationTypes.SET_SELECT_WINDOW, {
        open: false,
        title: "",
      });
  },
  computed: {
    categorySchedule: function () {
      const guest = this.store.state.selectFilters?.guestType
        ? this.store.state.selectFilters?.guestType
        : this.guestType[0];
      const en = "by day";
      const fr = "par jour";
      return [guest, "a - z", this.$store.state.language === "fr" ? fr : en];
    },
  },
})
export default class Main extends Vue {
  store = useStore();
  guests = guests;
  sortedDays = sortedDays;
  routeChoice = routeChoice;
  searchFilter = searchFilter;
  show = this.store.state.activeDayMenu.menu;
  tags: string[] | unknown[] = [
    ...new Set(
      guests
        .map((guest: { tags: string[] }) => guest.tags)
        .flat()
        .sort()
    ),
  ];
  guestType: string[] | unknown[] = [
    ...new Set(
      guests
        .map((guest: { type: string }) => guest.type)
        .flat()
        .sort()
    ),
  ];
  programs: string[] = data.data.programs
    .map((program) => program.name)
    .flat()
    .sort();
}
